import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { BariPostNurseSpecialistFollowUpBeoordelingEnVervolgDataBase } from './bariPostNurseSpecialistFollowUpDataBase';

export type BariPostNurseSpecialistFollowUpBeoordelingEnVervolgReadKeyBase =
    keyof BariPostNurseSpecialistFollowUpBeoordelingEnVervolgDataBase;

export type BariPostNurseSpecialistFollowUpLeefstijlEnMedicatieReadLabelBase =
    | 'Alcohol'
    | 'Aantal eenheden'
    | 'Anamnese (leefstijl, evt. klachten)'
    | 'Frequentie ontlasting'
    | 'Gebruik medicatie'
    | 'Gebruik multivitaminen'
    | 'Huidige medicatie'
    | 'Ontlasting'
    | 'Toelichting alcohol'
    | 'Toelichting deficiënties op basis van labuitslag'
    | 'Toelichting multivitaminegebruik';

export type BariPostNurseSpecialistFollowUpComorbiditeitenReadLabelBase =
    | 'Diabetes mellitus'
    | 'Dumpingklachten'
    | 'Dyslipidemie'
    | 'Gastroesophageal reflux disease'
    | 'Gewrichtsklachten'
    | 'GERD'
    | 'HbA1c'
    | 'Hypertensie'
    | 'Klachten van reflux'
    | 'Late dumping'
    | 'Medicamenteuze veranderingen'
    | 'OSAS'
    | 'Therapeutische veranderingen'
    | 'Toelichting dumpingklachten'
    | 'Toelichting gewrichtsklachten'
    | 'Toelichting medicamenteuze veranderingen'
    | 'Toelichting OSAS'
    | 'Toelichting therapeutische veranderingen'
    | 'Toelichting reflux'
    | 'Vroege dumping';

export type BariPostNurseSpecialistFollowUpBeoordelingEnVervolgReadLabelBase =
    | 'Beleid'
    | 'Datum verwijzing'
    | 'Expert'
    | 'Hulpvraag aan expert'
    | 'Interne expert inschakelen'
    | 'Extern doorverwijzen'
    | 'Verwijsbrief'
    | 'Type behandelaar'
    | 'Naam externe behandelaar'
    | 'Reden doorverwijzing';

export type BariPostNurseSpecialistFollowUpReadSectionTitleBase =
    | 'Beoordeling en vervolg'
    | 'Comorbiditeiten'
    | 'Leefstijl en medicatie';

export const beoordelingEnVervolgBase: TypedReadSchema<
    BariPostNurseSpecialistFollowUpBeoordelingEnVervolgReadKeyBase,
    BariPostNurseSpecialistFollowUpBeoordelingEnVervolgReadLabelBase,
    Extract<BariPostNurseSpecialistFollowUpReadSectionTitleBase, 'Beoordeling en vervolg'>
> = {
    items: [
        { key: 'beleid', label: 'Beleid' },
        {
            key: 'interne_expert_inschakelen',
            label: 'Interne expert inschakelen',
            type: 'boolean',
        },
        { key: 'expert', label: 'Expert' },
        { key: 'expert_hulpvraag', label: 'Hulpvraag aan expert' },
        { key: 'extern_doorverwijzen', label: 'Extern doorverwijzen', type: 'boolean' },
        { key: 'assets', label: 'Verwijsbrief' },
        { key: 'datum_verwijzing', label: 'Datum verwijzing', type: 'dateAsString' },
        { key: 'type_behandelaar', label: 'Type behandelaar' },
        { key: 'naam_externe_behandelaar', label: 'Naam externe behandelaar' },
        { key: 'reden_doorverwijzing', label: 'Reden doorverwijzing' },
    ],
    sectionTitle: 'Beoordeling en vervolg',
};
